export default __webpack_public_path__ + "static/media/강원.c125534b.png";